import { seoContent } from '@/mocks/seoData';

export default function Features() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            {seoContent.featuresTitle}
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg">
            Everything you need for efficient spreadsheet-based product sourcing in one place
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {seoContent.features.map((feature) => (
            <div
              key={feature.title}
              className="p-6 rounded-xl bg-background-50 border border-background-200/50 hover:border-primary-200/50 transition-all group"
            >
              <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}